import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { REPORT_TYPE, SEGMENT_BY } from '@constants/common/chart/chartConst';
import RadioButtons from '@lib/inputs/RadioButtons';
import { SegmentByContainer, FieldsetResetStyle, LegendStyle } from './styles';
import { Label } from 'semantic-ui-react';

function SegmentBy(props: {
    selectedReport: string;
    segmentBy: string;
    setSegmentBy: Function;
    isDrillDownActive: boolean;
    showAssigneeSegment?: boolean;
    isTagFilterApplied: boolean;
}) {
    const {
        selectedReport,
        segmentBy,
        setSegmentBy,
        isDrillDownActive,
        showAssigneeSegment = false,
        isTagFilterApplied,
    } = props;
    const firstOption =
        selectedReport === REPORT_TYPE.UPCOMING_DUE_DATES ? SEGMENT_BY.TAB_STATUS : SEGMENT_BY.WORKGROUP;
    const secondOption =
        selectedReport === REPORT_TYPE.UPCOMING_DUE_DATES ? SEGMENT_BY.TAB_DUE_DATE : SEGMENT_BY.ASSIGNEE;

    const getOptions = useMemo(() => {
        return [
            {
                id: 1,
                value: firstOption,
                text: firstOption,
            },
            {
                id: 2,
                value: secondOption,
                text: secondOption,
            },
        ];
    }, []);

    const isDisabled = useMemo(
        () => isDrillDownActive || (selectedReport !== REPORT_TYPE.UPCOMING_DUE_DATES && !isTagFilterApplied),
        [isDrillDownActive, selectedReport, isTagFilterApplied],
    );
    const intl = useIntl();
    return (
        <SegmentByContainer as="fieldset" className="--segment-by" style={FieldsetResetStyle}>
            <Label as="legend" style={LegendStyle}>{intl.formatMessage({id:'reports.label.segmentBy'})}</Label>
            <RadioButtons
                label={{
                    showRequiredIcon: false,

                    labelClass: [''],
                    ulClass: [''],
                    isLabelVisible: false,
                }}
                inputData={{
                    id: 'segmentBy',
                    isInputRequired: true,
                    type: 'radio',
                    options: getOptions,
                    value: segmentBy,
                    disabled: isDisabled,
                    liClass: ['text-left'],
                }}
                legend={{
                    dataInstructions: false,
                }}
                inputActions={{
                    handleFieldChange: value => setSegmentBy(value),
                }}
            />
        </SegmentByContainer>
    );
}

export default SegmentBy;
